import { render, staticRenderFns } from "./PersonalContact.html?vue&type=template&id=3190f7e0&scoped=true&"
import script from "./PersonalContact.js?vue&type=script&lang=js&"
export * from "./PersonalContact.js?vue&type=script&lang=js&"
import style0 from "./PersonalContact.scss?vue&type=style&index=0&id=3190f7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190f7e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VRow})
